module.exports = __webpack_public_path__ + "img/icon_memo_w.397a2864.svg";